<!--
 * @Author: 付康 fukang@yuouhui.com
 * @Date: 2022-11-01 14:32:32
 * @LastEditors: kangkang 1278279046@qq.com
 * @LastEditTime: 2022-11-16 10:03:38
 * @FilePath: /wxkn-experience/src/components/MiListItem.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="list-item" @click="gotoDetail">


        
      <div v-if="detail.type == 'NOTE'" >
        <div v-if="detail.noteVo.izTop == 'Y'" style="position: absolute; right:5px;top:0;">
          <van-tag plain type="primary">置顶</van-tag>
        </div>
        
        <div class="img-box">
          <van-image
            :src="detail.noteVo.cover"
            :mode="isAuto ? 'widthFix' : 'aspectFit'"
            @load="imgLoad"
          >
          </van-image>
        </div>
        <div class="label-text">
          {{ detail.noteVo.title }}
        </div>
        <div class="bottom-box">
          <div class="avatar-box">
            <van-image round width="30" height="30" :src="detail.noteVo.avatar" />
            <div style="">
              <div style="display: flex;align-items: center;">
                  <div  style="margin-left: 5px;display: flex;height: 15px; line-height: 15px;">
                      <div class="name" :style="detail.noteVo.izOfficial == 'Y' ? 'max-width:75px' : 'max-width:100px'"> {{
                          detail.noteVo.name
                        }}</div>
                    <div class="tag-text" style="margin-left:5px;"  v-if="detail.noteVo.izOfficial == 'Y'">官方</div>
                  </div>
              </div>
             
              
              <div
                class="school"
                style="margin-left: 5px"
                v-if="detail.noteVo.school.length > 0"
                >{{ detail.noteVo.school || "" }}</div
              >
            </div>
          </div>
          <div @tap.stop="likeAction" style="font-size: 11px;display: flex;align-items: center;">
            <van-icon
              color="red"
              v-if="detail.noteVo.izLike == 'Y'"
              name="like"
            />
            <van-icon name="like-o" v-else />
            <div class="praise-text">{{ likeNum }}</div>
          </div>
        </div>
      </div>
      <div v-else-if="detail.type == 'REQUIRE'"> 
        <RequireItem
          :item="detail.requireVo"
          :isNote="true"
          @shareAction="shareAction"
          @removeRequire="removeRequireAction"
        ></RequireItem>
      </div>
    </div>
  </template>
<script>
    import RequireItem from "@/components/MiRequireItem.vue";
    import cryptoDES from "@/util/cryptoDES";
    export default {
        data() {
            return {
                detail: this.noteData,
                isAuto: true,
            };
        },
        components: {
            RequireItem,
        },
        computed: {
            likeNum() {
                if (this.detail.type == 'NOTE') {
                    let num =
                        this.detail.noteVo.likeNum > 0 ? this.detail.noteVo.likeNum : "0";
                    if (num >= 10000 && num < 100000) {
                        num = num / 10000;
                        return parseFloat(num).toFixed(1) + "w";
                    }

                    if (num >= 100000 && num < 1000000) {
                        num = num / 100000;
                        return parseFloat(num).toFixed(1) + "w";
                    }

                    if (num >= 1000000) {
                        return "100w+";
                    }
                    return num;
                }
                return 0;
            },
        },
        props: {
            noteData: {
                typeof: Object,
                default: () => {},
            },
        },
        mounted() {},
        methods: {
            shareAction() {
                this.$emit("shareAction");
            },
            imgLoad(img) {

            },
            likeAction() {

            },
            gotoDetail() {
                let that = this;
                if (this.detail.type == "NOTE") {
                    let query = {
                        noteId: cryptoDES.encrypt(this.detail.noteVo.id)
                    };
                    this.$router.push({
                        path: "miplaza/detail",
                        query: query,
                    });
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .list-item {
        background: #fff;
        width: calc((100vw - 30px) / 2);
        margin-bottom: 10px;
        border-radius: 7px;
        position: relative;
        // border: solid 1px #ebebeb;
        .img-box {
            width: 100%;
            margin-bottom: 10px;
            image {
                width: 100%;
                border-top-left-radius: 7px;
                border-top-right-radius: 7px;
            }
        }
        .label-text {
            margin-top: 7px;
            padding: 0 7px;
            font-weight: 600;
            font-size: 16px;
            line-height: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            /* 超出部分省略号 */
            word-break: break-all;
            /* break-all(允许在单词内换行。) */
            display: -webkit-box;
            /* 对象作为伸缩盒子模型显示 */
            -webkit-box-orient: vertical;
            /* 设置或检索伸缩盒对象的子元素的排列方式 */
            -webkit-line-clamp: 2;
            /* 显示的行数 */
            height: 40px;
        }
        .bottom-box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 7px;
            .avatar-box {
                display: flex;
                align-items: center;
                font-size: 13px;
                color: #333;
                .name {
                    /* width: 120px; */
                    font-size: 12px;
                    display: -webkit-box;
                    /* 对象作为伸缩盒子模型显示 */
                    overflow: hidden;
                    text-overflow: ellipsis;
                    /* 超出部分省略号 */
                    -webkit-line-clamp: 1;
                    /* 显示的行数 */
                    -webkit-box-orient: vertical;
                }
                .school {
                    width: 70px;
                    font-size: 9px;
                    display: -webkit-box;
                    /* 对象作为伸缩盒子模型显示 */
                    overflow: hidden;
                    text-overflow: ellipsis;
                    /* 超出部分省略号 */
                    -webkit-line-clamp: 1;
                    /* 显示的行数 */
                    -webkit-box-orient: vertical;
                }
            }
            .praise-text {
                color: #666666;
                margin-left: 5px;
            }
        }
    }
    
    .tag-text {
        font-size: 9px;
        border: 1px solid #3d7eff;
        color: #3d7eff;
        /* padding: 0px 5px; */
        border-radius: 2px;
        line-height: 13px;
        height: 12px;
        width: 25px;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/MiListItem.vue